var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004A77",
    stroke: "current",
    className: "st0",
    d: "M15.1694 0.467489C15.4661 0.0074361 16.0592 -0.135878 16.5238 0.140214C16.9885 0.416307 17.1645 1.01664 16.9257 1.51113L11.3906 12.9752C10.9303 13.9286 9.78379 14.2846 8.88791 13.7523C7.99203 13.2199 7.71833 12.02 8.29044 11.133L15.1694 0.467489Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004A77",
    stroke: "current",
    className: "st0",
    d: "M2.89672 6.92894C4.78065 5.05357 7.33581 4 10.0001 4C10.4854 4 10.7696 4.56789 10.5526 5C10.3686 5.36626 9.73952 5.99373 9.3296 6.02787C7.44375 6.18497 5.66569 7.00098 4.3174 8.34315C3.04838 9.60639 2.2476 11.2486 2.02623 13.0026C1.95707 13.5505 1.51379 14 0.958982 14C0.404175 14 -0.0507986 13.5512 0.00457369 13.0016C0.234869 10.7161 1.25069 8.56749 2.89672 6.92894Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#004A77",
    stroke: "current",
    className: "st0",
    d: "M17.1033 6.92894C18.7493 8.56749 19.7651 10.7161 19.9954 13.0016C20.0508 13.5512 19.5958 14 19.041 14C18.4862 14 18.0429 13.5505 17.9738 13.0026C17.7524 11.2486 16.9516 9.60639 15.6826 8.34315C15.4759 8.13738 15.6788 7.55386 15.8258 7.30116C15.8261 7.30063 15.8257 7.3 15.825 7.3C15.8244 7.3 15.824 7.29933 15.8243 7.2988C16.0958 6.83461 16.7218 6.54916 17.1033 6.92894Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/Counter.9e4509062ec96238ca124d7d9e193759.svg";
export { ForwardRef as ReactComponent };